import { createContext, useContext } from "react";
import { PreparedData } from "../config/data";

export interface DataContextType {
  preparedData: PreparedData | undefined;
  isLoading: boolean;
}

export const DataContext = createContext<DataContextType | undefined>(undefined);

export function useData(): DataContextType {
  const context = useContext(DataContext);
  if (context === undefined) {
    throw new Error("useData must be used within a DataProvider");
  }
  return context;
}
